import axios 						from 'axios'
import store 						from "@/store"
import api 							from "@/api"
import router 					from "@/router"
// console.log("Store ", store.getters["auth/user"])
// Requests
try{

	// let user = helper.get_local('user');
	const user = store.getters["auth/user"];
	axios.defaults.withCredentials 	= 	false;
	if (user && user.jwt) {
		axios.defaults.headers.common["Authorization"] = `Bearer ${user.jwt}`;
		// axios.defaults.headers.common['CLIENT_IP'] = ""
	}
}catch(e){
	console.warn("Error convert json usr", e);
}

const getConfiguredTimezone = () => {
	try {
		const stored = localStorage.getItem('time_zone');
		if (stored) return JSON.parse(stored);
	} catch (_) { /* noop */ }
	try {
		return Intl.DateTimeFormat().resolvedOptions().timeZone;
	} catch (_) { /* noop */ }
	return 'UTC';
};

const isOurBackend = (url) => {
	if (!url) return false;
	if (url.startsWith('/')) return true;
	if (!api) return false;
	if (api.url      && url.startsWith(api.url))      return true;
	if (api.url_face && url.startsWith(api.url_face)) return true;
	return false;
};

if (!axios.__tzInterceptorInstalled) {
	axios.interceptors.request.use(config => {
		if (isOurBackend(config.url)) {
			const tz = getConfiguredTimezone();
			config.params = Object.assign({}, config.params || {}, { tz });
		}
		return config;
	});
	axios.__tzInterceptorInstalled = true;
}

const clearInvalidSession = () => {
	try {
		localStorage.removeItem('user');
	} catch (_) { /* noop */ }

	try {
		delete axios.defaults.headers.common["Authorization"];
	} catch (_) { /* noop */ }

	try {
		store.commit('auth/logout');
	} catch (_) { /* noop */ }
};

const shouldClearSession = (error) => {
	const response = error && error.response;
	if (!response) return false;

	const data = response.data || {};
	if (response.status === 403 && data === 'Forbidden') return true;
	if (response.status !== 401) return false;

	return data.msg === 'Invalid authentication token: user id is missing';
};

if (!axios.__invalidSessionInterceptorInstalled) {
	axios.interceptors.response.use(
		response => response,
		error => {
			if (shouldClearSession(error)) {
				clearInvalidSession();

				if (router && router.currentRoute && router.currentRoute.path !== '/') {
					router.replace('/').catch(() => {});
				}
			}

			return Promise.reject(error);
		}
	);
	axios.__invalidSessionInterceptorInstalled = true;
}

export default axios;
